import React from 'react';
import './Styles/Create.scss';
import Tilt from 'react-parallax-tilt';
import image from '../../../Assets/Cards/create-c.png';
import profile from '../../../Assets/Cards/profile1.png';
const Create=()=>{
    return(
        <div className="create-c">
            <div className="image-part">
            <Tilt scale={0.9} transitionSpeed={3500}>
            <img className="mainimg" src={image} />
            </Tilt>
            <div className="testimonial" data-aos="zoom-in"
              data-aos-delay={200}>
                        <div className="name">
                         <img  src={profile} />
                         <h3>John Petla</h3>
                        </div>
                        <p>we need more work here. Please add some images here.</p>
                         <div className="post">
                             <p>Just Now</p>
                             <p> Mark as done</p>
                             <p>Reply</p>
                         </div>
                    </div>
            <div className="share" data-aos="zoom-in"
              data-aos-delay={200}>
                <h2>Share Link</h2>
                <div className="inputpart">
                    <p>Link</p>
                    <h3>https://my.hostdesign.com/publinmk /show?code-ASSDasa34fsddfs3f</h3>
                </div>
                <div className="inputpart">
                    <p>Send Link to</p>
                    <div className="input-group">
                            <div className="checked">
                                <p>testproject@gmail.com</p>
                               
                            </div>
                            <input type="text" placeholder="Add more people..."/>
                        </div>
                </div>
            </div>
          
            </div>
            <div className="content">
                <h1>Create and iterate , together</h1>
                <p>It's our mission to democratise design collaboration which will improve the creative process - making design more inclusive, collaborative and innovative.</p>
                <p>Instant access to all company projects for your directory members, means full visibility for your colleagues and helps you get to your best idea fast</p>
            </div>
            

        </div>
    )
};
export default Create ;